import { useApolloClient } from '@apollo/client'
import DataTable from '@mostrans/web-components/components/advanced/DataTable'
import Button from '@mostrans/web-components/components/base/Button'
import { Chip, Link } from '@mui/material'
import React, { useEffect, useState } from 'react'
import { useParams } from 'react-router-dom'
import { useResetRecoilState, useSetRecoilState } from 'recoil'
import { GetCandidateRecruitmentResult } from '../../../GQL/queries'
import { errInputAtom, globalLoadingScreenAtom } from '../../../shared/globalStates'
import { toastError } from '../../../shared/helpers'
import ModalAssignResult from './modals/ModalAssignResult'

function CandidateResult(props) {
    const [listResult, setListResult] = useState([])
    const [modalIsOpen, setModalIsOpen] = useState(false)
    const [idResult, setIdResult] = useState()
    const [filesUpload, setFilesUpload] = useState("")
    const [urlFile, setUrlFile] = useState("")
    const [resultValue, setResultValue] = useState({ resultName: "", remarks: "" })
    const { dataCandidateByID } = props
    const client = useApolloClient()
    const { opportunityID } = useParams()
    const resetErrInput = useResetRecoilState(errInputAtom)
    const setIsLoading = useSetRecoilState(globalLoadingScreenAtom)

    const fetchCandidateResult = () => {
        try {
            setIsLoading(true)
            GetCandidateRecruitmentResult(client, dataCandidateByID.id, parseInt(opportunityID)).then(
                (data) => setListResult(data)
            )
        } catch (error) {
            toastError(error)
        } finally {
            setIsLoading(false)
        }
    }

    useEffect(() => {
        fetchCandidateResult()
    }, [client])


    const clearStateProps = () => {
        setUrlFile()
        setFilesUpload()
        setResultValue({ remarks: "", resultName: "" })
    }


    const handleModalIsOpen = async (value) => {
        try {
            setIsLoading(true)
            setIdResult(value)
            clearStateProps()
            resetErrInput()
            setModalIsOpen((event) => !event)
        } catch (error) {
            toastError(error)
        } finally {
            setIsLoading(false)
        }
    }


    const column = [
        {
            getCellKey: (data) => <p>{data?.status}</p>,
            selector: "status",
            header: "Tahap",
            sortBy: "status",
            sortable: true,
        },
        {
            renderCell: (data) => {
                return data.result ? <Chip label={data?.result}
                    color={data?.result === 'PASSED' ? 'primary' : data?.result === 'CONSIDER' ? 'warning' : 'error'}
                    variant="outlined" /> : <p>No data</p>
            },
            selector: "result",
            header: "Result",
            sortBy: "result",
            sortable: true
        },
        {
            renderCell: (data) => {
                return data.remarks ? <p>{data?.remarks}</p> : <p>No data</p>
            },
            selector: "remarks",
            header: "Remarks",
            sortBy: "remarks",
            sortable: true
        },
        {
            renderCell: (data) => {
                return data.link_attachment ?
                    <Link
                        href={data?.link_attachment}
                        underline="hover"
                        target='_blank'>
                        View Attachment
                    </Link>
                    :
                    <p>No data</p>
            },
            selector: "link_attachment",
            header: "Attachment",
            sortBy: "link_attachment",
            sortable: true,
        },
        {
            renderCell: (data) => {
                return data.date_process ? <p>{data.date_process}</p> : <p>No data</p>
            },
            selector: "date_process",
            header: "Result Date"
        },
        {
            renderCell: (data) => (
                <Button onClick={() => handleModalIsOpen(data.id)}>
                    {
                        data.result ? "Update Result" : "Assign Result"
                    }
                </Button>
            ),
            selector: "id",
            header: "Action",
        },
    ];

    return (
        < React.Fragment >
            <ModalAssignResult
                modalIsOpen={modalIsOpen}
                handleModalIsOpen={handleModalIsOpen}
                idResult={idResult}
                filesUpload={filesUpload}
                setFilesUpload={setFilesUpload}
                urlFile={urlFile}
                setUrlFile={setUrlFile}
                resultValue={resultValue}
                setResultValue={setResultValue}
                fetchCandidateResult={fetchCandidateResult} />
            <div className='mt-2'>
                <DataTable
                    data={listResult}
                    columns={column}
                    hasPagination={true}
                    headerRowStyle={() => ({ fontSize: 13 })}
                    conditionalRowStyle={() => ({ fontSize: 13 })}
                />
            </div>
        </React.Fragment >
    )
}

export default CandidateResult